(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAcc(section) {
      if (section.dataset.cnsInit === '1') return;
      var items = Array.prototype.slice.call(section.querySelectorAll('.accordion-hero__item'));
      if (!items.length) return;
      section.dataset.cnsInit = '1';

      items.forEach(function (item) {
        var head = item.querySelector('.accordion-hero__head');
        if (!head) return;
        head.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var h = other.querySelector('.accordion-hero__head');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            item.classList.add('is-open');
            head.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll('.accordion-hero'), initAcc);
    }

    if (document.readyState !== 'loading') initAll();
    else
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefit-orbit"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 1100px)') : { matches: false };

  function initStp(root) {
    if (root.dataset.stpInit === '1') return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.benefit-orbit__card'));
    if (!cards.length) return;
    root.dataset.stpInit = '1';

    var figs = Array.prototype.slice.call(root.querySelectorAll('.benefit-orbit__fig'));
    var labels = Array.prototype.slice.call(root.querySelectorAll('.benefit-orbit__olabel'));
    var orbiter = root.querySelector('.benefit-orbit__orbiter');
    var arrows = Array.prototype.slice.call(root.querySelectorAll('.benefit-orbit__arrow'));
    var counts = Array.prototype.slice.call(root.querySelectorAll('.benefit-orbit__count'));

    function parseAngles(attr) {
      return (root.getAttribute(attr) || '').split(',').map(function (x) { return parseFloat(x); });
    }
    var anglesD = parseAngles('data-angles');
    var anglesM = parseAngles('data-angles-m');
    var N = cards.length;
    var current = 0;

    function angleFor(i) {
      var arr = MQ.matches ? anglesM : anglesD;
      return arr && arr.length ? arr[i] : NaN;
    }

    function go(i) {
      current = Math.max(0, Math.min(N - 1, i));
      cards.forEach(function (c, k) {
        c.classList.toggle('is-active', k === current);
        c.setAttribute('aria-current', k === current ? 'true' : 'false');
      });
      figs.forEach(function (f, k) { f.classList.toggle('is-active', k === current); });
      labels.forEach(function (l, k) { l.classList.toggle('is-active', k === current); });
      var ang = angleFor(current);
      if (orbiter && !isNaN(ang)) orbiter.style.transform = 'rotate(' + ang + 'deg)';
      counts.forEach(function (c) { c.textContent = (current + 1) + '/' + N; });
      arrows.forEach(function (a) {
        var dir = parseInt(a.getAttribute('data-dir'), 10);
        a.disabled = (dir === -1 && current === 0) || (dir === 1 && current === N - 1);
      });
    }

    arrows.forEach(function (a) {
      a.addEventListener('click', function () { go(current + parseInt(a.getAttribute('data-dir'), 10)); });
    });
    cards.forEach(function (c, i) { c.addEventListener('click', function () { go(i); }); });
    labels.forEach(function (l, i) { l.addEventListener('click', function () { go(i); }); });

    // re-aim the orbit marker when crossing the mobile breakpoint
    var reaim = function () { go(current); };
    if (MQ.addEventListener) MQ.addEventListener('change', reaim);
    else if (MQ.addListener) MQ.addListener(reaim);

    go(0);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.benefit-orbit'), initStp);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-chart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCmp(root) {
    if (root.dataset.cmpInit === '1') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.comparison-chart__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.comparison-chart__panel'));
    if (!tabs.length) return;
    root.dataset.cmpInit = '1';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var view = tab.getAttribute('data-view');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-view') === view);
        });
      });
    });

    // Reveal the horizontal scrollbar only while actively scrolling
    Array.prototype.slice.call(root.querySelectorAll('.comparison-chart__scroll')).forEach(function (sc) {
      var t;
      sc.addEventListener('scroll', function () {
        sc.classList.add('is-scrolling');
        clearTimeout(t);
        t = setTimeout(function () { sc.classList.remove('is-scrolling'); }, 800);
      }, { passive: true });
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.comparison-chart'), initCmp);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHiw(root) {
    if (root.dataset.hiwInit === '1') return;
    root.dataset.hiwInit = '1';

    var figs = Array.prototype.slice.call(root.querySelectorAll('.hiw__fig'));
    var copies = Array.prototype.slice.call(root.querySelectorAll('.hiw__copy'));
    var arrows = Array.prototype.slice.call(root.querySelectorAll('.hiw__arrow'));
    var count = root.querySelector('.hiw__count');
    var current = 0;
    var N = figs.length;
    if (!N) return;

    function go(i) {
      current = Math.max(0, Math.min(N - 1, i));
      figs.forEach(function (f, k) { f.classList.toggle('is-active', k === current); });
      copies.forEach(function (c, k) { c.classList.toggle('is-active', k === current); });
      if (count) count.textContent = (current + 1) + '/' + N;
      arrows.forEach(function (a) {
        var dir = parseInt(a.getAttribute('data-dir'), 10);
        a.disabled = (dir === -1 && current === 0) || (dir === 1 && current === N - 1);
      });
    }

    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        go(current + parseInt(a.getAttribute('data-dir'), 10));
      });
    });

    // Swipe on touch devices — swipe the image left/right to change steps
    var media = root.querySelector('.hiw__media');
    if (media) {
      var startX = 0, startY = 0, tracking = false;
      media.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX; startY = t.clientY; tracking = true;
      }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        // horizontal swipe only — ignore mostly-vertical (page scroll) gestures
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          go(current + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    go(0);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.hiw')).forEach(initHiw);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(hero) {
    if (hero.dataset.hyInit === '1') return;
    var tabs   = Array.prototype.slice.call(hero.querySelectorAll('.tabbed-hero-tab'));
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.tabbed-hero__media img'));
    var copies = Array.prototype.slice.call(hero.querySelectorAll('.tabbed-hero__copy'));
    var captions = Array.prototype.slice.call(hero.querySelectorAll('.tabbed-hero__tab-caption'));
    if (!tabs.length) return;
    hero.dataset.hyInit = '1';

    var autoplayMs = parseInt(hero.getAttribute('data-autoplay-ms'), 10) || 0;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoplayMs = 0;
    }
    hero.style.setProperty('--tabbed-hero-dur', (autoplayMs || 6000) + 'ms');
    if (!autoplayMs) hero.setAttribute('data-autoplay', 'off');

    var current = 0;
    var timer = null;

    function activate(index) {
      current = index;
      tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      slides.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
      copies.forEach(function (p, i) { p.classList.toggle('is-active', i === index); });
      captions.forEach(function (c, i) { c.classList.toggle('is-active', i === index); });
      var fill = tabs[index].querySelector('.tabbed-hero-tab__fill');
      if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
      queueNext();
    }

    function queueNext() {
      if (timer) clearTimeout(timer);
      if (!autoplayMs) return;
      timer = setTimeout(function () { activate((current + 1) % tabs.length); }, autoplayMs);
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
    });
    queueNext();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.tabbed-hero'), initHero);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Theme editor: (re)initialise when this section is added or reloaded.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
